import { useEffect, useState } from "react"
import SessionsDashboard from "./Dashboard"
import { WorkspaceForm } from "./WorkspaceForm";

export const AppWrapper = () => {
    const [workspaceId, setWorkspaceId] = useState();

    useEffect(() => {
        const q = new URLSearchParams(window.location.search);
        const workspaceId = q.get("workspaceId");
        if (workspaceId) setWorkspaceId(workspaceId);
    }, [])

    if (!workspaceId) return <WorkspaceForm />
    return <SessionsDashboard workspaceId={workspaceId} />
}